module.exports = __webpack_public_path__ + "files/SPIADI2019 - Rapport National.8e28be3c1da0a4c19fe1972d921ebec5.pdf";